import { createApp } from 'vue'
import { createPinia } from 'pinia'

import { setupDayjs } from './plugins/dayjs'
import { getLocaleString, i18n } from './plugins/i18n'

import { StorageService } from '@/services/storage.service'

import '@ui-lib/index.css'
import '@/scss/styles.scss'

import App from './App.vue'
import { APP_ID } from './config/constants.config'
import { PREFILL_KEYS } from './config/prefill.config'
import { setDataAttributesFromUrl } from '@/helpers/set-data-attributes-from-url.helpers.ts'
import { APP_SETTING_KEYS } from './config/app-setting.config'
import { gtm } from './plugins/gtm'
import { initializeSentry } from './plugins/sentry'

const mountElement = document.getElementById(APP_ID)
if (!mountElement) throw new Error('[Leasing Calculator]: Missing mount element')

export const app = createApp(App)
export const pinia = createPinia()

const urlParams = new URLSearchParams(window.location.search)

async function initializeApp() {
  // Set up locale
  StorageService.updateDataFromStorage('sessionStorage', 'locale', getLocaleString())
  i18n.global.locale = getLocaleString()

  // Set up plugins
  setupDayjs()

  // Automatically initialize Sentry in case the environment is not Production
  if (!import.meta.env.PROD) {
    initializeSentry()
  }

  // Use plugins
  app.use(pinia).use(i18n)
  app.use(gtm(import.meta.env.VITE_APP_GTM_ID))

  app.mount(`#${APP_ID}`)
}

setDataAttributesFromUrl(mountElement, urlParams, [...APP_SETTING_KEYS, ...PREFILL_KEYS] as const)

initializeApp()
